import { Flat } from "@/app/api/types";
import { Entity, INumberField } from "@/app/fields/types";
import { InputLeftAddon, InputRightAddon } from "@chakra-ui/react";
import { NumberInputFieldProps, useFormContext } from "@saas-ui/forms";

type IUnits = Pick<NumberInputFieldProps, "leftAddon" | "rightAddon">;

export const useGetNumberAddons = <T extends Entity>(): ((
  field: INumberField<T>
) => IUnits) => {
  const { watch } = useFormContext();
  const formValues = watch() as Flat<T>;

  const fn = ({ units }: INumberField<T>): IUnits => {
    if (!units) {
      return {};
    }
    const { label, position } = units;
    const AddOn = position === "left" ? InputLeftAddon : InputRightAddon;
    let displayLabel;
    try {
      const getUnitsFn = eval(label) as (value: Flat<T>) => string;
      displayLabel = getUnitsFn(formValues);
    } catch (e) {
      displayLabel = label;
    }
    return {
      [`${position}Addon`]: (
        <AddOn data-cy={`${position}-add-on`}>{displayLabel}</AddOn>
      ),
    };
  };

  return fn;
};
